import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PoojaBooking from "./poojaBooking/poojaBooking";
import ServiceDonation from "./Donation/donation";
import DonorAdvisoryFunds from "./DonorAdvisoryFunds/donorAdvisoryFunds";
import MatchingDonations from "./MatchingDonations/matchingDonations";
import HallRental from "./HallRental/hallRental";
import Vastaras from "./Vastras/vastaras";
import PrasadamPurchase from "./Purchase/prasadamPurchase";
import Calendar from "./Calendar/calendarPurchase";
import ModifyProfile from "./ModifyProfile/modifyProfile";
import Refund from "./Refund/refund";
import Categories from "./categories/categories";
import DevoteePoojaHallRequest from "./DevoteePoojaHallRequest/devoteePoojaHallRequest";
import {
  checkAuthToken,
  getDevoteeId,
  getaccessToken,
} from "../../infrastructure/backendService";
import DevoteeBookPooja from "../devotee/devoteeBooking/bookPooja";
import PersonalInfo from "../devoteeManagement/PersonalInfo";
import RegisterDevotee from "../devoteeManagement/RegisterDevotee";
import SearchDevotee from "./searchDevotee/searchDevotee";
// import HallRentalComponent from "../devotee/devoteeBooking/hallRental";
import { isNil } from "lodash";
import UserDetails from "../common/user/userDetails";
import { SubRoutingURLs } from "../common/RoutingURLs";
import ConsolidatedAccounts from "../devoteeManagement/ConsolidatedAccounts";
import DuplicateDevotee from "../devoteeManagement/DuplicateDevotee";
import RestoreConsolidatedAccounts from "../devoteeManagement/RestoreConsolidatedAccounts";
import DeletedDevoteeList from "../devoteeManagement/DeletedDevoteeList";
import UnSubscribeComponent from "../devoteeManagement/unSubscribe";
import PriestScheduleReport from "../priestSchedule/priestScheduleReport";
import ScMembersTabs from "../scMembers/scMembersTabs";
import VastraDetails from "../systemSettings/vastraDetails/vastraDetails";
import DonationType from "../systemSettings/donationTypes/donationType";
import DonationPurpose from "../systemSettings/donationPurpose/donationPurpose";
import PoojaDetails from "../systemSettings/poojaDetails/poojaDetails";
import PoojaDetailsTable from "../systemSettings/poojaDetails/poojaDetailsTable";
import DonationTable from "../systemSettings/donationTypes/donationTable";
import EventHalls from "../systemSettings/eventsHalls/eventHalls";
import EventHallsTable from "../systemSettings/eventsHalls/eventhallsTable";
import PriestSeniority from "../systemSettings/priestSeniority/priestSeniority";
import AddVastraType from "../systemSettings/vastraType/AddVastraType";
import DailyActivities from "../systemSettings/dailyActivities/DailyActivities";
import VastraPurpose from "../systemSettings/vastraPurpose/VastraPurpose";
import ManagementTeamCategory from "../systemSettings/managementTeamCategory/managementTeamCategory";
import DataEntryVendors from "../dataEntry/vendors/vendors";

const DevoteeServiceRoutes = () => {
  const [searchParam] = useSearchParams();

  const DevoteeId = searchParam.get("DevoteeId");

  const { devoteeServiceType } = useParams();

  const searchDevoteeRoutes = [
    SubRoutingURLs.POOJA_BOOKING,
    SubRoutingURLs.HALL_RENTAL,
    SubRoutingURLs.REFUND,
    SubRoutingURLs.LADDU_OR_KARASEV_OR_VADA,
    SubRoutingURLs.DONATION,
    SubRoutingURLs.VASTRA,
    SubRoutingURLs.DONOR_ADVISORY_FUNDS,
    SubRoutingURLs.MATCHING_DONATIONS,
    SubRoutingURLs.MODIFY_DEVOTEE_PROFILE,
    SubRoutingURLs.CATEGORIES,
  ];

  const includesSearchDevotee = searchDevoteeRoutes.includes(
    devoteeServiceType || ""
  );

  const [showSearchDevotee, setShowSearchDevotee] = useState<boolean>(true);

  useEffect(() => {
    setShowSearchDevotee(isNil(getDevoteeId()?.userId) && includesSearchDevotee);
  }, [DevoteeId, includesSearchDevotee]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!checkAuthToken()) {
      navigate("/");
    }
  }, [getaccessToken()]);

  const handleBackClick = () => {
    setShowSearchDevotee(true);
    navigate(window.location.pathname);
    sessionStorage.removeItem("devoteeID");
  };

  let componentToRender: JSX.Element;

  switch (devoteeServiceType) {
    // case "ACCESS_CONTROL":
    //   // componentToRender = <SearchDevotee />;
    //   break;
    case SubRoutingURLs.POOJA_BOOKING:
      componentToRender = <PoojaBooking onBackClick={handleBackClick} />;
      break;
    case SubRoutingURLs.DONATION:
      componentToRender = (
        <ServiceDonation
          username={getDevoteeId()?.userId || ""}
          onBackClick={handleBackClick}
        />
      );
      break;
    case SubRoutingURLs.DONOR_ADVISORY_FUNDS:
      componentToRender = (
        <DonorAdvisoryFunds
          username={getDevoteeId()?.userId || ""}
          onBackClick={handleBackClick}
        />
      );
      break;
    case SubRoutingURLs.MATCHING_DONATIONS:
      componentToRender = (
        <MatchingDonations
          username={getDevoteeId()?.userId || ""}
          onBackClick={handleBackClick}
        />
      );
      break;
    case SubRoutingURLs.VASTRA:
      componentToRender = (
        <Vastaras
          username={getDevoteeId()?.userId || ""}
          onBackClick={handleBackClick}
        />
      );
      break;
    case SubRoutingURLs.HALL_RENTAL:
      componentToRender = <HallRental onBackClick={handleBackClick} />;
      break;
    case SubRoutingURLs.EVENT_HALL_BOOKING_REQUEST:
      componentToRender = <HallRental onBackClick={handleBackClick} />;
      break;
    case SubRoutingURLs.LADDU_OR_KARASEV_OR_VADA:
      componentToRender = (
        <PrasadamPurchase
          username={getDevoteeId()?.userId || ""}
          onBackClick={handleBackClick}
        />
      );
      break;
    case SubRoutingURLs.MODIFY_PROFILE:
      componentToRender = <ModifyProfile />;
      break;
    case SubRoutingURLs.REFUND:
      componentToRender = <Refund onBackClick={handleBackClick} />;
      break;
    case SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS:
      componentToRender = <DevoteePoojaHallRequest />;
      break;
    case SubRoutingURLs.MODIFY_DEVOTEE_PROFILE:
      componentToRender = <UserDetails />;
      break;
    case SubRoutingURLs.calendar:
      componentToRender = <Calendar username={getDevoteeId()?.userId || ""} />;
      break;
    case SubRoutingURLs.devoteePoojaRequest:
      componentToRender = <DevoteeBookPooja />;
      break;
      case SubRoutingURLs.CATEGORIES:
      componentToRender = <Categories onBackClick={handleBackClick} />;
      break;

    // devotee management
    case SubRoutingURLs.CONSOLIDATE_ACCOUNTS:
      componentToRender = <ConsolidatedAccounts />;
      break;
    case SubRoutingURLs.DUPLICATE_DEVOTEE_RECORDS:
      componentToRender = <DuplicateDevotee />;
      break;
    case SubRoutingURLs.RESTORE_CONSOLIDATE_ACCOUNTS:
      componentToRender = <RestoreConsolidatedAccounts />;
      break;
    case SubRoutingURLs.DELETED_DEVOTEE_LIST:
      componentToRender = <DeletedDevoteeList />;
      break;
    case SubRoutingURLs.unSubscribe:
      componentToRender = <UnSubscribeComponent />;
      break;
    case SubRoutingURLs.QUICK_REGISTRATION:
      componentToRender = <PersonalInfo />;
      break;
    case SubRoutingURLs.REGISTER_DEVOTEE:
      componentToRender = <RegisterDevotee />;
      break;

    // // reports section
    // case SubRoutingURLs.PRIESTS_SCHEDULE_SUMMARY_CONSOLIDATED:
    //   componentToRender = <PriestScheduleReport />;
    //   break;

    // SCM Meetings
    case SubRoutingURLs.SCM_MANAGEMENT:
      componentToRender = <ScMembersTabs />;
      break;
    //systme settings
    case SubRoutingURLs.DAILY_ACTIVITIES:
      componentToRender = <DailyActivities />;
      break;
    case SubRoutingURLs.VASTRA_PURPOSE:
      componentToRender = <VastraPurpose />;
      break;
    case SubRoutingURLs.VASTRA_TYPES:
      componentToRender = <AddVastraType />;
      break;
    case SubRoutingURLs.VASTRA_DETAILS:
      componentToRender = <VastraDetails />;
      break;
    case SubRoutingURLs.DONATION_TYPES:
      componentToRender = <DonationTable />;
      break;
    case SubRoutingURLs.DONATION_PURPOSE:
      componentToRender = <DonationPurpose />;
      break;
    case SubRoutingURLs.POOJA_DETAILS:
      componentToRender = <PoojaDetailsTable />;
      break;
    case SubRoutingURLs.EVENT_HALLS:
      componentToRender = <EventHallsTable />;
      break;
    case SubRoutingURLs.PRIEST_SENIORITY:
      componentToRender = <PriestSeniority />;
      break;
    case SubRoutingURLs.MANAGEMENT_TEAM_CATEGORIES:
      componentToRender = <ManagementTeamCategory />;
      break;
    default:

      componentToRender = <div>Page not found</div>;
  }

  window.scroll(0, 180);

  const needsBackButton = includesSearchDevotee && !showSearchDevotee;

  const renderwithButtonComponent = (): JSX.Element => {
    return (
      <>
        {needsBackButton && (
          <div
            onClick={handleBackClick}
            style={{ marginTop: "9px", marginBottom: "10px" }}
          ></div>
        )}
        {componentToRender}
      </>
    );
  };

  // Ensure to update the render function to not override the conditional rendering
  const render = () => {
    if (
      !showSearchDevotee ||
      devoteeServiceType === SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS ||
      devoteeServiceType === SubRoutingURLs.REGISTER_DEVOTEE ||
      devoteeServiceType === SubRoutingURLs.QUICK_REGISTRATION
    ) {
      return renderwithButtonComponent();
    } else if (showSearchDevotee) {
      return <SearchDevotee setShowSearchDevotee={setShowSearchDevotee} />;
    } else {
      sessionStorage.setItem("devoteeID", DevoteeId || "");
      // Handling for the default case or specific navigation logic
      return componentToRender;
    }
  };

  return <>{render()}</>;
};

export default DevoteeServiceRoutes;
